import "./polyfills/heatmapImageData";
import App from "./App";
import React from "react";
import { App as AntApp } from "antd";
import { createRoot } from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import UXloader from "./components/layouts/UXloader";
import ThemeProvider from "./components/ThemeProvider";
import StripeProvider from "./components/StripeProvider";
import ChartProvider from "./components/charts/ChartProvider";
import Notification from "./components/toolkit/components/layouts/Notification";
import posthog from "posthog-js";
import { PostHogProvider } from "@posthog/react";

import { Provider } from "react-redux";
import { store, persistor } from "./store";
import { PersistGate } from "redux-persist/integration/react";

// Import Fonts
import "@fontsource/inter/100.css";
import "@fontsource/inter/200.css";
import "@fontsource/inter/300.css";
import "@fontsource/inter/400.css";
import "@fontsource/inter/500.css";
import "@fontsource/inter/600.css";
import "@fontsource/inter/700.css";
import "@fontsource/inter/800.css";
import "@fontsource/inter/900.css";

import "@fontsource/poppins/300.css";
import "@fontsource/poppins/400.css";
import "@fontsource/poppins/500.css";
import "@fontsource/poppins/600.css";
import "@fontsource/poppins/700.css";

import "@fontsource/montserrat/300.css";
import "@fontsource/montserrat/400.css";
import "@fontsource/montserrat/500.css";
import "@fontsource/montserrat/600.css";
import "@fontsource/montserrat/700.css";
import "@fontsource/montserrat/800.css";

import "simplebar-react/dist/simplebar.min.css";
import "react-quill/dist/quill.snow.css";
import "./assets/css/quill-editor.css";
import "./assets/css/comments.css";
import "./assets/css/antd-overrides.css";
import "./assets/css/app.css";
import "./assets/css/projects.css";
import "./assets/css/fullcalendar.css";

// import * as Sentry from "@sentry/react";

const {
  NODE_ENV,
  // REACT_APP_SENTRY_DSN,
  // REACT_APP_SENTRY_ENV,
  // REACT_APP_SENTRY_REPLAY_SESSION_SAMPLE_RATE,
  // REACT_APP_SENTRY_REPLAY_ERROR_SESSION_SAMPLE_RATE,
  REACT_APP_PUBLIC_POSTHOG_KEY,
  REACT_APP_PUBLIC_POSTHOG_HOST,
} = process.env;

// if (NODE_ENV !== "development") {
//   Sentry.init({
//     tracesSampleRate: 1.0,
//     dsn: REACT_APP_SENTRY_DSN,
//     environment: REACT_APP_SENTRY_ENV,
//     replaysSessionSampleRate: REACT_APP_SENTRY_REPLAY_SESSION_SAMPLE_RATE,
//     replaysOnErrorSampleRate: REACT_APP_SENTRY_REPLAY_ERROR_SESSION_SAMPLE_RATE,
//     integrations: [new Sentry.Replay(), new Sentry.BrowserTracing()],
//   });
// }

const shouldEnablePostHog = NODE_ENV !== "development" && !!REACT_APP_PUBLIC_POSTHOG_KEY && !!REACT_APP_PUBLIC_POSTHOG_HOST;

if (shouldEnablePostHog) {
  posthog.init(REACT_APP_PUBLIC_POSTHOG_KEY, {
    api_host: REACT_APP_PUBLIC_POSTHOG_HOST,
    defaults: "2026-01-30",
    capture_pageview: "history_change",
    autocapture: true,
    capture_pageleave: true,
    disable_session_recording: false,
  });
}

const AppTree = (
  <HelmetProvider>
    <Provider store={store}>
      <PersistGate loading={<UXloader />} persistor={persistor}>
        <ThemeProvider>
          <StripeProvider>
            <ChartProvider>
              <AntApp>
                <App />
                <Notification />
              </AntApp>
            </ChartProvider>
          </StripeProvider>
        </ThemeProvider>
      </PersistGate>
    </Provider>
  </HelmetProvider>
);

createRoot(document.getElementById("root")).render(
  shouldEnablePostHog ? <PostHogProvider client={posthog}>{AppTree}</PostHogProvider> : AppTree
);
